import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import TimelineNavigator from "../../../navigation/TimelineNavigator";
import styles from "./timeline.module.css";

const Timeline = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("timelines", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/timelines/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <TimelineNavigator />
    </div>
  );
};

export default Timeline;
